// src/components/AddPaymentModal.js

import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, CircularProgress, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const AddPaymentModal = ({ isOpen, onClose, onSave, kalanTutar = 0, customerName }) => {
  const [tutar, setTutar] = useState('');
  const [odemeYontemi, setOdemeYontemi] = useState('Nakit');
  const [aciklama, setAciklama] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    // Modal açıldığında ve kalan tutar varsa, tutar alanını doldur
    if (isOpen && kalanTutar > 0) {
      setTutar(kalanTutar.toString());
    } else if (!isOpen) {
      // Modal kapandığında formu sıfırla
      setTutar('');
      setOdemeYontemi('Nakit');
      setAciklama('');
    }
  }, [isOpen, kalanTutar]);

  const handleSubmit = async () => {
    const tutarSayi = parseFloat(tutar);
    if (!tutar || tutarSayi <= 0) {
      alert('Lütfen geçerli bir tutar giriniz.');
      return;
    }
    // Fazla tahsilat: kalanTutar'ı negatife düşürür ve iş emri silinirse bakiyeyi yanlış yöne çeker.
    if (kalanTutar > 0 && tutarSayi > kalanTutar + 0.01) {
      const fark = tutarSayi - kalanTutar;
      const onay = window.confirm(
        `Girilen tutar, iş emrinin kalan bakiyesinden ${fark.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })} fazla.\n\n` +
        `Kalan: ${kalanTutar.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}\n` +
        `Girilen: ${tutarSayi.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}\n\n` +
        `Yine de kaydedilsin mi?`
      );
      if (!onay) return;
    }
    setIsSaving(true);
    try {
      // Kaydetme mantığını dışarıdan gelen onSave fonksiyonuna devrediyoruz
      await onSave({
        tutar: tutarSayi,
        odemeYontemi: odemeYontemi,
        aciklama: (aciklama || `Ödeme (${odemeYontemi})`).toLocaleUpperCase('tr-TR'), // Faz 4.5: BÜYÜK HARF
      });
      onClose(); // Yalnızca gerçekten kaydedildiyse kapat
    } catch (error) {
      // Modal KAPANMAZ: kullanıcı hatayı görsün ve tekrar denesin (sahte başarı gösterme)
      console.error("Ödeme kaydedilirken hata: ", error);
      alert(`Ödeme kaydedilemedi: ${error?.message || error}`);
    } finally {
      setIsSaving(false);
    }
  };
  
  // G5: bu modal YALNIZ İş Emri Detay'dan açılır; uyarı metinleri iş emri bağlamına sabittir.
  const title = customerName ? `Ödeme Ekle: ${customerName}` : 'Ödeme Ekle (İş Emri)';

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField label="Tutar (₺)" type="number" value={tutar} onChange={(e) => setTutar(e.target.value)} required autoFocus />
          <FormControl fullWidth>
            <InputLabel>Ödeme Yöntemi</InputLabel>
            <Select value={odemeYontemi} label="Ödeme Yöntemi" onChange={(e) => setOdemeYontemi(e.target.value)}>
              <MenuItem value="Nakit">Nakit</MenuItem>
              <MenuItem value="Kredi Kartı">Kredi Kartı</MenuItem>
              <MenuItem value="Havale/EFT">Havale/EFT</MenuItem>
            </Select>
          </FormControl>
          <TextField label="Açıklama (Opsiyonel)" value={aciklama} onChange={(e) => setAciklama(e.target.value)} multiline rows={2} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px' }}>
        <Button onClick={onClose} disabled={isSaving}>İptal</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={isSaving}>
          {isSaving ? <CircularProgress size={24} /> : 'Kaydet'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPaymentModal;